import ExternalLogin from './ExternalLogin';

export default ExternalLogin;
